import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { IonSpinner } from '@ionic/angular/standalone'

@Component({
  selector: 'mcm-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonSpinner]
})
export class LoaderComponent {
  readonly loading = input(false)
  readonly noHeight = input(false)
  readonly isWhiteSpinnerColor = input(false)
}
